import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

import Section from "../section/section"
import ScrollStat from "./scrollstat"

import { StatsContainer } from "./stats.styled"

const Stats = ({ data }) => {
  const {
    heading,
    flexHeading,
    leftBoxWidths,
    rightBoxWidths,
    button,
    statsIntro,
    stats,
    statWidth = [106, null, null, 191],
  } = data

  return (
    <StatsContainer className="bg-nova-base-black">
      <Section as="div">
        <Box
          width={1}
          mb={[112, null, 112, 128]}
          className={flexHeading ? "hide-md-up" : ""}
        >
          <TextElementNova
            text={heading}
            element="h2"
            className={`Title-20-Super-Normal text-nova-base-white ${
              button ? "mb-[24px]" : ""
            }`}
          />
          {button ? (
            <div className="flex">
              <ButtonNova
                ctaLink={button.destination}
                label={button.label}
                icon={`Left`}
                level={button.level}
                copyClassName="text-nova-base-white"
                trackObject={{
                  destination: button.destination,
                  type: "link",
                  text: button.label,
                }}
              />
            </div>
          ) : null}
        </Box>
        <Flex flexWrap="wrap">
          <Box
            width={leftBoxWidths || [1, null, 0.5, 0.58]}
            mb={flexHeading ? [0] : [24, 24, 0]}
            className="sm:flex sm:flex-col"
          >
            {flexHeading ? (
              <TextElementNova
                text={flexHeading}
                element="p"
                className="Title-20-Super-Normal text-nova-base-white show-md-up flex-heading md:pr-6"
              />
            ) : null}
            {statsIntro ? (
              <TextElementNova
                text={statsIntro}
                element="p"
                className="Body-30-Dia-Strong text-nova-base-white sm:mt-auto sm:w-[275px] md:w-[320px]"
              />
            ) : null}
          </Box>
          <Box width={rightBoxWidths || [1, null, 0.5, 0.42]} mb={[0]}>
            {stats.map((stat, i) => (
              <React.Fragment key={i}>
                <ScrollStat
                  stat={stat}
                  statsLength={stats.length}
                  i={i}
                  statWidth={statWidth}
                  moduleName={flexHeading || heading}
                />
              </React.Fragment>
            ))}
          </Box>
        </Flex>
      </Section>
    </StatsContainer>
  )
}

export default Stats
